import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventLocationFields from './EventLocationFields'

export const EventLocationEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <EventLocationFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default EventLocationEdit
